module.exports = __webpack_public_path__ + "static/assets/42299392cb209e0f8f5ae770a0ff53fd.svg";